
import React from 'react'
import six_img from "../../../../images/config/authorizationProgress/6.png"
class AuthorizationConfiguration extends React.Component {

    render() {
        return (
            <div className={'authorizationConfiguration'}>
                <div>
                    <div>选择【客户联系】-【权限配置】，点击【添加/修改】将成员添加到使用范围，建议选择全部成员</div>
                    <div>员工只有配置了【使用范围和管理规则】才可以使用客户联系，添加外部联系人等权限，请确保客服等人员被添加客户联系权限，否则可能会导致紫鲲部分功能无法使用</div>
                    <div><img src={six_img}/></div>
                </div>
            </div>
        )
    }
}

export default AuthorizationConfiguration
